import React from 'react';
import css from 'styled-jsx/css';
import ButtonBecomeCreator from '../ButtonBecomeCreator';
import Container from '~/components/Container';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';
import { SERVICE_TYPES } from '~/utils/constants';

const BACKGROUND_BY_SERVICE_TYPE = {
  [SERVICE_TYPES.PHOTO_AC]: `${config.staticPrefix}/static/images/submission-guideline-page/mobile-view/requirements-image-photo-ac.png`,
  [SERVICE_TYPES.ILLUST_AC]: `${config.staticPrefix}/static/images/submission-guideline-page/mobile-view/requirements-image-illust-ac.png`,
};

const MobileView = ({ t }) => {
  return (
    <div className="mobile-view-wrapper">
      <Container style={{ zIndex: 1 }}>
        <img
          className="img-background lazyload"
          data-srcset={BACKGROUND_BY_SERVICE_TYPE[config.serviceType]}
          alt="img background"
        />
      </Container>
      <Container
        className={containerClassName}
        contentClassName={contentClassName}
      >
        <h2 className="title">
          {t(config.getPrefixContent('requirements_title'))}
        </h2>
        {config.isPhotoAC() ? (
          <div className="description">
            <div className="list-item">
              {t('requirements_for_photos_item_1')}
            </div>
            <div className="list-item">
              {t('requirements_for_photos_item_2')}
            </div>
            <div className="list-item">
              {t('requirements_for_photos_item_3')}
            </div>
            <div className="list-item">
              {t('requirements_for_photos_item_4')}
            </div>
            <div className="list-item">
              {t('requirements_for_photos_item_5')}
            </div>
          </div>
        ) : (
          <div className="description">
            <div className="list-item">
              {t('requirements_for_vectors_item_1')}
            </div>
            <div className="list-item">
              {t('requirements_for_vectors_item_2')}
            </div>
            <div className="list-item">
              {t('requirements_for_vectors_item_3')}
            </div>
            <div className="list-item">
              {t('requirements_for_vectors_item_4')}
            </div>
            <div className="list-item">
              {t('requirements_for_vectors_item_5')}
            </div>
            <div className="list-item">
              {t('requirements_for_vectors_item_6')}
            </div>
          </div>
        )}
        <ButtonBecomeCreator style={{ marginTop: 16 }} t={t} />
      </Container>
      <style jsx>{styles}</style>
      {containerStyles}
      {contentStyles}
    </div>
  );
};

const { className: containerClassName, styles: containerStyles } = css.resolve`
  width: 100%;
  background: ${config.isPhotoAC() ? '#1b2833' : '#454285'};
  margin-top: ${config.isPhotoAC() ? '32px' : '-10%'};
`;

const { className: contentClassName, styles: contentStyles } = css.resolve`
  position: relative;
  padding-top: 48px;
  padding-bottom: 48px;
  display: flex;
  flex-direction: column;
`;

const styles = css`
  .mobile-view-wrapper {
    width: 100%;
    background: #f8f9fa;
  }

  .img-background {
    width: 100%;
    margin-top: 32px;
  }

  .title {
    font-size: 24px;
    font-weight: 600;
    padding: 0;
    margin: 0;
    color: #fff;
  }

  .description {
    margin-top: 24px;
    color: #f8f9fa;
  }
  .list-item {
    margin-bottom: 8px;
  }
`;

export default MobileView;
